(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jennys-brand-style"] && !Shopify.designMode) return;
  try {
    (() => {
 if(!document.documentElement.lang.startsWith('ja'))return;
 let pending=false;
 const run=()=>{pending=false;document.querySelectorAll('[class*="yotpo"]').forEach(el=>{for(const node of el.childNodes){if(node.nodeType===3 && node.textContent.includes('お客様からの満足感'))node.textContent=node.textContent.replace('お客様からの満足感','件のレビュー');}});};
 const start=()=>{const root=document.getElementById('MainContent');if(root)new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(run);}}).observe(root,{subtree:true,childList:true,characterData:true});run();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jennys-unit-value"] && !Shopify.designMode) return;
  try {
    (() => {
 let pending=false;
 const update=()=>{
  pending=false;
  const unit=document.querySelector('[data-jr-unit-count]');
  if(!unit || unit.dataset.jrUnitCurrency!=='JPY')return;
  const active=document.querySelector('.sls-option-container.sls-active');
  const raw=active?.querySelector('.sls-price .money')?.textContent.match(/[¥￥]\s*([\d,]+(?:\.\d+)?)/)?.[1];
  if(!raw)return;
  const amount=Number(raw.replaceAll(',',''))/Number(unit.dataset.jrUnitCount);
  if(!Number.isFinite(amount))return;
  const subscription=!!active.querySelector('input[data-type="subscription"]');
  const en=document.documentElement.lang.startsWith('en');
  const approx=Math.abs(amount-Math.round(amount))>0.001;
  const price='¥'+Math.round(amount).toLocaleString('ja-JP');
  const text=en?(approx?'About ':'')+price+' per cookie':'1枚'+(approx?' 約':' ')+price;
  const context=en?' · '+unit.dataset.jrUnitCount+' cookies · '+(subscription?'First subscription order':'One-time purchase')+', tax included':' · '+unit.dataset.jrUnitCount+'枚入り · '+(subscription?'定期便初回':'通常購入')+'・税込';
  const p=unit.querySelector('[data-jr-unit-price]'),c=unit.querySelector('[data-jr-unit-context]');
  if(p.textContent!==text)p.textContent=text;
  if(c.textContent!==context)c.textContent=context;
 };
 const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
 const start=()=>{const root=document.querySelector('product-info');if(root)new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});document.addEventListener('change',schedule);update();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
